import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateExpedienteParteRequest extends CreateKeyValueRequest {
  public idExpediente!: number
  public idTipoParte!: number
  public idPersona!: number
}
